import * as tslib_1 from "tslib";
import * as React from 'react';
import { observer } from 'mobx-react';
import { TeachingBubble } from 'office-ui-fabric-react/lib/TeachingBubble';
import { ButtonType } from 'office-ui-fabric-react/lib/Button';
import { lightable, lighted, eventMgr, SettingPanelFirstRunCalloutDismissedEvent, } from 'owa-lightning';
import hideQuickOptions from 'owa-options-actions/lib/hideQuickOptions';
import { logUsage } from 'owa-analytics';
import strings from 'owa-strings/owa-configurator-strings';
var SettingPanelFirstRunCallout = /** @class */ (function (_super) {
    tslib_1.__extends(SettingPanelFirstRunCallout, _super);
    function SettingPanelFirstRunCallout(props) {
        var _this = _super.call(this, props) || this;
        _this.onGotIt = function () {
            lighted(_this.props.lid);
        };
        _this.onNotNow = function () {
            logUsage('SettingPanelFirstRunNotNow');
            hideQuickOptions();
            lighted(_this.props.lid);
            eventMgr.emit(SettingPanelFirstRunCalloutDismissedEvent);
        };
        return _this;
    }
    SettingPanelFirstRunCallout.prototype.render = function () {
        var gotItButtonProps = {
            buttonType: ButtonType.primary,
            children: strings.callout_Gotit,
            onClick: this.onGotIt,
        };
        var notNowButtonProps = {
            children: strings.callout_Notnow,
            onClick: this.onNotNow,
        };
        return (React.createElement(TeachingBubble, { calloutProps: {
                beakWidth: 15,
                directionalHint: 12 /* rightCenter */,
                gapSpace: 30,
            }, targetElement: this.props.target(), hasCloseIcon: true, headline: strings.callout_Panel_Title, hasSmallHeadline: true, primaryButtonProps: gotItButtonProps, secondaryButtonProps: notNowButtonProps, onDismiss: this.onGotIt }, strings.callout_Panel_Body));
    };
    SettingPanelFirstRunCallout = tslib_1.__decorate([
        observer,
        lightable
    ], SettingPanelFirstRunCallout);
    return SettingPanelFirstRunCallout;
}(React.Component));
export { SettingPanelFirstRunCallout };
//# sourceMappingURL=SettingPanelFirstRunCallout.js.map